import type { InjectionKey, SetupContext } from 'vue'
import type { UseNamespaceReturn } from '@code-monkey-ui/hooks'

interface DatePickerContext {
  slots: SetupContext['slots']
  pickerNs: UseNamespaceReturn
}

export const ROOT_WEEK_PICKER_INJECTION_KEY: InjectionKey<DatePickerContext> =
  Symbol()
